import { useContent } from "@/context/ContentContext";

// Returns the list of course titles used across all lead forms as a dropdown.
// Includes courses + consultancy programs so a single dropdown covers everything.
export function useCourseOptions() {
  const { content } = useContent();
  const courses = (content?.sections?.courses?.items || []).map((c) => c.title).filter(Boolean);
  const programs = (content?.sections?.consultancy?.programs || []).map((p) =>
    p.code ? `${p.code} — ${p.title || p.code}` : p.title
  ).filter(Boolean);
  return [...courses, ...programs, "Other / Not sure yet"];
}
